import { FunctionComponent } from 'react'
import styled, { css } from 'styled-components'

const StyledLineItem = styled.div`
  ${({
    theme: {
      colors: {
        grey: { grey_30 },
      },
    },
  }) => css`
    height: 1px;
    width: 50px;
    background-color: ${grey_30};
    margin: 3.5px 0;
  `}
`

const LineItem: FunctionComponent = () => {
  return <StyledLineItem role="presentation" />
}

export default LineItem
